import { createContext, useContext } from 'react';
import { useQuery } from 'react-query';
import { getHandbook } from '~/api/handbook';
import { useSetLanguage } from '~/hooks/i18nHooks';

export const useHandbook = () => {
  const { language } = useSetLanguage();

  return useQuery(['handbook', language], getHandbook, { staleTime: Infinity });
};

export type HandbookKeys = {
  nationality: string;
  country: string;
  relation: string;
  legalType: string;
  idType: string;
  calendarType: string;
  bank: string;
  mcc: string;
  region: string;
};

export const HandbookKeysContext = createContext<HandbookKeys>({
  nationality: 'nationality',
  country: 'entitycountryofestablishment',
  relation: 'relation',
  legalType: 'legaltype',
  idType: 'idType',
  calendarType: 'calendarType',
  bank: 'bank',
  mcc: 'mcc',
  region: 'region',
});

export const useHandbookKeys = (): HandbookKeys => {
  const keys = useContext(HandbookKeysContext);
  return keys;
};
